module.exports = __webpack_public_path__ + "static/beach-cooler.7b8d833d.jpg";